import { createAction } from 'Helpers';
import notificationTypes from './types';

const notificationActions = {
	fetchNotificationsRequest: createAction(notificationTypes.FETCH.REQUEST),
	fetchNotificationsSuccess: createAction(notificationTypes.FETCH.SUCCESS),
	fetchNotificationsFailure: createAction(notificationTypes.FETCH.FAILURE),
	fetchNotificationsClear: createAction(notificationTypes.FETCH.CLEAR),

	updateNotificationsRequest: createAction(notificationTypes.UPDATE.REQUEST),
	updateNotificationsSuccess: createAction(notificationTypes.UPDATE.SUCCESS),
	updateNotificationsFailure: createAction(notificationTypes.UPDATE.FAILURE),
	updateNotificationsClear: createAction(notificationTypes.UPDATE.CLEAR),
};

export default notificationActions;
